// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Media-module__ui-Media--KBBLG {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  padding-block: 26px;
}

.Media-module__media--zKgRK {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid #d6d0c7;
  box-shadow: 0 2px 6px rgb(0 0 0 / 14%);
}

.Media-module__media--zKgRK > :only-child,
.Media-module__media--zKgRK > :only-child > img {
  display: block;
  object-fit: cover;
}

.Media-module__title--qR9R2,
.Media-module__description--wpkVD {
  overflow: hidden;
  font-family: var(--chaek-font-family-gowun-dodum);
  font-weight: 400;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  word-break: keep-all;
  text-align: center;
}

.Media-module__title--qR9R2 {
  margin-top: 12px;
  color: var(--chaek-color-text-primary);
  font-size: 1rem;
  line-height: 1.4;
}

.Media-module__description--wpkVD {
  margin-top: 3px;
  color: var(--chaek-color-text-muted);
  font-size: 0.75rem;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Media/Media.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".ui-Media {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-start;\n  padding-block: 26px;\n}\n\n.media {\n  position: relative;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  overflow: hidden;\n  border: 1px solid #d6d0c7;\n  box-shadow: 0 2px 6px rgb(0 0 0 / 14%);\n}\n\n.media > :only-child,\n.media > :only-child > img {\n  display: block;\n  object-fit: cover;\n}\n\n.title,\n.description {\n  overflow: hidden;\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-weight: 400;\n  text-overflow: ellipsis;\n  /* white-space: nowrap; */\n  word-break: keep-all;\n  text-align: center;\n}\n\n.title {\n  margin-top: 12px;\n  color: var(--chaek-color-text-primary);\n  font-size: 1rem;\n  line-height: 1.4;\n}\n\n.description {\n  margin-top: 3px;\n  color: var(--chaek-color-text-muted);\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Media": `Media-module__ui-Media--KBBLG`,
	"media": `Media-module__media--zKgRK`,
	"title": `Media-module__title--qR9R2`,
	"description": `Media-module__description--wpkVD`
};
export default ___CSS_LOADER_EXPORT___;
